import { render, staticRenderFns } from "./ParcelListSelector.vue?vue&type=template&id=b8157bc2&scoped=true"
import script from "./ParcelListSelector.vue?vue&type=script&lang=js"
export * from "./ParcelListSelector.vue?vue&type=script&lang=js"
import style0 from "./ParcelListSelector.vue?vue&type=style&index=0&id=b8157bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8157bc2",
  null
  
)

export default component.exports